import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SmoothScroll from "@/components/SmoothScroll";
import LoadCurtain from "@/components/LoadCurtain";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/EditorialMarquee";
import Manifesto from "@/components/Manifesto";
import StudioSection from "@/components/StudioSection";
import Quiz from "@/components/Quiz";
import Footer from "@/components/Footer";
import AdminPage from "@/pages/AdminPage";

function LandingPage() {
  const scrollToQuiz = () => {
    const el = document.getElementById("quiz");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="App relative bg-obsidian text-cream" data-testid="landing-page">
      <div className="grain-overlay" aria-hidden />
      <LoadCurtain />
      <Header />
      <main>
        <Hero onStart={scrollToQuiz} />
        <EditorialMarquee />
        <Manifesto />
        <StudioSection />
        <Quiz />
      </main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <SmoothScroll>
              <LandingPage />
            </SmoothScroll>
          }
        />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </BrowserRouter>
  );
}
